import axios from "axios";
import { notifyError } from "./notificationService";
import { obtenerToken, cerrarSesion } from "./authService";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 30000
});

api.interceptors.request.use((config) => {
    const token = obtenerToken();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const estado = error.response?.status;

        if (estado === 401 && window.location.pathname !== "/login") {
            cerrarSesion();
            window.location.replace("/login");
        }
        else if (estado === 403) {
            notifyError("No tiene permisos para realizar esta acción.");
        }
        else if (estado === 500) {
            notifyError("Ocurrió un error interno en el servidor.");
        }
        else if (!error.response) {
            notifyError("No se pudo conectar con el servidor.");
        }

        return Promise.reject(error);
    }
);

export default api;
